import { Button, Form, Input, Radio, Space, Select, Row, Col, Avatar, Switch, Tooltip, Upload, Tabs } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import { UserOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useParams, useLoaderData, useOutletContext, useNavigate } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { MdEdit } from 'react-icons/md';
import { RxUpdate } from "react-icons/rx";
import EventEmitter from '../../utils/eventEmitter';
import useContactAPI from '../apis/contactsAPI';
import ContactAddress from '../modals/ContactAddress';
import { ACCOUNTING_URL } from '../../utils/axios';
import axios from 'axios';



// const address_type = [
//   {value: '', label: ''},
//   {value: 'contact', label: 'Contact'},
//   {value: 'invoice_address', label: 'Invoice Address'},
//   {value: 'delivery_address', label: 'Delivery Address'},
//   {value: 'Other address', label: 'Other Address'},
//   {value: 'private_address', label: 'Private Address'}
// ]


const ContactChanges = () => {
  const {contact, companies, titles, tags} = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(contact.name ? contact.name : '');
  const [contactType, setContactType] = useState(contact.type ? contact.type: 'individual');
  const { create, update } = useContactAPI();
  const [accounts, setAccounts] = useState([]);

  const onChangeName = (e) => setName(e.target.value);
  const toggleContactType = e => setContactType(e.target.value);

  const save = () => {
    let data = form.getFieldsValue();
    data['name'] = name;
    const { city, region, street_address, street2 } = data.address;
    data['street_address'] = street_address;
    delete data.address;
    create(data, success);
    // console.log(data);
  }

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    const { city, region, street_address, street2 } = data.address;
    data['street_address'] = street_address;
    delete data.address;
    update(contact.seo, data, success);
    // console.log(data)
  };

  useEffect(() => {
    EventEmitter.subscribe('contact_created', data => {
      navigate('/sales/customers/'+data);
    });
    
    return () => EventEmitter.unsubscribe('contact_created');
  },[])

  const openAddContactModal = () => {
    EventEmitter.dispatch('create_contact_modal_open', true);
  }

  useEffect(() => {
    axios.get(ACCOUNTING_URL+'accounts/expose/other-modules')
    .then(res => setAccounts(res.data))
    .catch(err => console.log(err))
  },[])

  return (
    <div className='container mx-auto' style={{ maxWidth: '1000px' }}>
      <div className='flex justify-between'>
        <div>
          <h3 className='font-bold'>
            <Link to={'/sales/customers'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Customers</Link> / {params.action}
            <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={save} type='text' htmlType='button'
              disabled={contact.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={edit} type='text' htmlType='button'
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
          </h3>
          {contact.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
        </div>
        
      </div>  
      <div className='mt-5 p-3 bg-white shadow p-3'>
        
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 8  }}
          labelWrap={true}
          initialValues={contact.seo ? {...contact, address: {street_address: contact.street_address}} : { type: 'individual'}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Form.Item name="type" className="font-bold mb-1" required>
            <Radio.Group onChange={toggleContactType}>
              <Space >
                <Radio value="individual">Individual</Radio>
                <Radio value="company">Company</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
            
          <Row>
            <Col  md={{ span: 11 }}>
              <FloatingLabel
                className='text-2xl'
                variant="standard"
                // disabled={formValue.status!== 'discard' ? true : false}
                placeholder="Name"
                value={name} 
                onChange={onChangeName}
              />
              {contactType === 'individual' && <Form.Item name={'company_id'}>
                <Select options={companies.map(company => ({value: company.id, label: company.name}))} placeholder='company'/>
              </Form.Item>}
            </Col>
            <Col md={{ span: 3, offset: 9 }}>
              <Upload 
                name="picture"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                style={{height: '30px'}}
                
              >
                <Avatar icon={<UserOutlined />} />
              </Upload>
            </Col>
          </Row>

          <Row>
            <Col md={{span: 11}}>
              {/* {contactType === 'individual' && <Form.Item label='Address Type' name="address_type" className='font-bold mb-1' required >
                <Select options={address_type}/>
              </Form.Item>}
             */}
              <Form.Item label='Address' className='font-bold mb-1' required >
                <Space.Compact direction='vertical'>
                  <Form.Item name={['address', 'street_address']} noStyle>
                    <Input type='text' className='input-outline-none font-normal' placeholder='street 1' name='street_address' />
                  </Form.Item>
                  <Form.Item name={['address', 'street2']} noStyle>
                    <Input type='text' className='input-outline-none font-normal' placeholder='street 2' name='street2' />
                  </Form.Item>
                </Space.Compact>
                <Row>
                  <Col md = {{span: 11}}>
                    <Form.Item name={['address', 'region']} noStyle>
                      <Select options={[]} placeholder='region' name='region' className='font-normal' />
                    </Form.Item>
                  </Col>
                  <Col md = {{span: 11, offset: 2}}>
                    <Form.Item name={['address', 'city']} noStyle>
                      <Select options={[]} placeholder='city' name='city' className='font-normal'/>
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item> 
              
              
            </Col>
            <Col md={{span: 11, offset: 1}}>
              {contactType === 'individual' && <Form.Item label='Job Position' name="job_position" className='font-bold mb-1' required >
                <Input type='text' className='input-outline-none font-normal py-1' placeholder='software engineer' />
              </Form.Item>}
              <Form.Item label='Phone' name="phone_number1" className='font-bold mb-1' required >
                <Input type='tel' className='input-outline-none font-normal py-1' placeholder='0123456789'/>
              </Form.Item>
              <Form.Item label='Mobile' name="phone_number2" className='font-bold mb-1' required >
                <Input type='tel' className='input-outline-none font-normal py-1' placeholder='0123456789' />
              </Form.Item>
              <Form.Item label='Email' name="email" className='font-bold mb-1' required >
                <Input type='email' className='input-outline-none font-normal py-1' placeholder='johndoe@email.com' />
              </Form.Item>
              <Form.Item label='Website Link' name="website" className='font-bold mb-1' required >
                <Input type='url' className='input-outline-none font-normal py-1' placeholder='johndoe.com' />
              </Form.Item>
              {contactType === 'individual' && <Form.Item label='Title' name="title_id" className='font-bold mb-1' required >
                <Select options={titles.map(title => ({value: title.id, label: title.name}))} placeholder='Mister' className='font-normal'/>
              </Form.Item>}
              <Form.Item label='Tags' name="tag_ids" className='font-bold mb-1' required >
                <Select mode='tags' options={tags.map(tag => ({value: tag.id, label: tag.name}))} placeholder='software developer' className='font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type='card'
            items={[
              {
                key: '1',
                label: 'Contact & Addresses',
                children: 
                <div className='p-3'>
                  <Button className='border-0' onClick={openAddContactModal}>ADD</Button>
                </div>
              },
              {
                key: '2',
                label: 'Sales & Purchase',
                children: 
                  <Row>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-lg bg-transparent	p-0 ">Sales</Badge>
                      <Form.Item label='Salesperson' className='mb-1 font-bold'>
                        <Select options={[]}/>
                      </Form.Item>
                      <Form.Item label='Delivery Method' className='mb-1 font-bold'>
                        <Select options={[]}/>
                      </Form.Item>
                      <Form.Item label='Payment Terms' className='mb-1 font-bold'>
                        <Select options={[]}/>
                      </Form.Item>

                      <Badge className="text-slate-500 text-lg bg-transparent	p-0 mt-5">Point Of Sale</Badge>
                      <Form.Item label='Barcode' className='mb-1 font-bold'>
                        <Input type='text' className='input-outline-none font-normal'/>
                      </Form.Item>
                      <Form.Item label='Loyalty Points' className='mb-1 font-bold'>
                        <Input className='input-outline-none font-normal' />
                      </Form.Item>

                      <Badge className="text-slate-500 text-lg bg-transparent	p-0 mt-5">MISC</Badge>
                      <Form.Item label='Reference' className='mb-1 font-bold'>
                        <Input type='text' className='input-outline-none font-normal'/>
                      </Form.Item>
                    </Col>
                    <Col md={{span: 11, offset: 1}}>
                      <Badge className="text-slate-500 text-lg bg-transparent	p-0 ">Purchase</Badge>
                      <Form.Item label='Payment Terms' className='mb-1 font-bold'>
                        <Select options={[]}/>
                      </Form.Item>
                      <Form.Item label='Receipt Reminder' className='mb-1 font-bold'>
                        <Select options={[]}/>
                      </Form.Item>
                    </Col>
                  </Row>
              },
              {
                key: '3',
                label: 'Accounting',
                forceRender: true,
                children: 
                  <Row className='mb-3'>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">RECEIVABLES</Badge>
                      <Form.Item label='Account Receivable' name='account_receivable_id' className='font-semibold mb-1' >
                        <Select options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='font-normal' />
                      </Form.Item>
                    </Col>  
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 ps-0 text-md bg-transparent	border-b-2 my-3">PAYABLES</Badge>
                      <Form.Item label='Account Payable' name='account_payable_id' className='font-semibold mb-1' >
                        <Select options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))} className='font-normal' />
                      </Form.Item>
                    </Col>  
                  </Row> 
              },
              {
                key: '4',
                label: 'Internal Notes',
                children: 
                  <>
                    <FloatingLabel
                      className='text-lg'
                      variant="standard"
                      placeholder="Internal note..."
                      // value={name} 
                      // onChange={onChangeName}
                    />
                  </>
              }
            ]}
          />
        </Form>
      </div>
      <ContactAddress />
    </div>
  )
}

export default ContactChanges;